import React from 'react';
import ShowIf from './ShowIf.jsx';
import {arrayObjectIndexOf} from './method.jsx';

class ItemParents extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: this.props.value,
      label: this.props.label,
      dataSelected: this.props.dataSelected,
      status: false,
      showChildren: false,
      only: this.props.only,
      itemSelected:this.props.value,
      selected: false
    }
  }

  componentDidMount() {
    this.checkDataSelected();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value,
      label: nextProps.label,
      dataSelected: nextProps.dataSelected,
      itemSelected: nextProps.itemSelected
    }, () => {
      this.checkDataSelected();
    })
  }

  onCheck() {
    this.setState({
      status: !this.state.status
    },()=> {
      this.pushOutData()
    })
  }

  pushOutData() {
    if (this.state.only) {
      let dataPush = this.state.value
      this.props.selectedOption(dataPush);
    } else {
      let dataPush = {
        value: this.state.value,
        label: this.state.label
      }
      if (this.state.status) {
        this.props.selectedOption(dataPush);
      } else {
        this.props.removeOption(dataPush);
      }
    }
  }

  toggleChilden() {
    this.setState({
      showChildren: !this.state.showChildren
    })
  }

  checkDataSelected() {
    if(this.state.only) {
      if (this.state.value == this.state.itemSelected) {
        this.setState({
          selected: true
        })
      } else {
        this.setState({
          selected: false
        })
      }
    } else {
      if (arrayObjectIndexOf(this.state.dataSelected, this.state.value, 'value') == -1) {
        this.setState({
          status: false
        })
      } else {
        this.setState({
          status: true
        })
      }
    }
  }

  render() {
    return (
      <div className={this.props.children && this.props.children.length > 0 ? 'rs-parents has-children pl25' : 'rs-parents pl25'}>
        <ShowIf condition={!this.state.only}>
          <span className='rs-wrap-ckeckbox'>
            <input type="checkbox" checked={this.state.status} value={this.state.status} onChange={this.onCheck.bind(this)}/>
            <span className='rs-checked-icon'></span>
          </span>
        </ShowIf>
        <ShowIf condition={typeof this.props.children != 'undefined' && this.props.children.length > 0}>
          <span className={this.state.showChildren ? 'rs-toggle-children showed' : 'rs-toggle-children'} onClick={this.toggleChilden.bind(this)}></span>
        </ShowIf>
        <span className={this.state.selected ? 'rs-label rs-selected' : 'rs-label'} onClick={this.onCheck.bind(this)}>{this.state.label}</span>
        <div className={this.state.showChildren ? '' : 'hidden'}>
          {
            this.props.children
          }
        </div>
      </div>
    );
  }
}

ItemParents.defaultProps = {
  value: '',
  label: '',
  dataSelected: [],
  only: false,
  itemSelected: ''
}

export default ItemParents;


// WEBPACK FOOTER //
// ./src/components/tt-forms/react-tree-select/ItemParents.jsx